import React, { useMemo } from 'react';
import { mapMembersToCohortList } from 'js/utils/cohort-utils';
import Cohort from './Cohort';

import styles from './CohortList.module.scss';

export function CohortList({ members }) {
  const memberCohorts = useMemo(
    () => mapMembersToCohortList(members),
    [members]
  );

  return (
    <div className={styles['cohort-list']}>
      {memberCohorts.map((cohort) => (
        <Cohort key={cohort.cohort} cohort={cohort} />
      ))}
    </div>
  );
}

export default CohortList;
